import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../shared/shared.module';
import { CoreModule } from '../core/core.module';
import {LegacyLogoutComponent} from "./logout/legacy-logout.component";


@NgModule({
    declarations: [
        LegacyLogoutComponent,
    ],
    imports: [
        SharedModule,
        RouterModule,
        CoreModule
    ],
    exports: [
        LegacyLogoutComponent
    ]
})
export class LegacyLogoutModule { }
